module.exports = __webpack_public_path__ + "static/img/LoanShowRight.8574bb88.png";